// PATH: src/pages/Donativos.jsx
// VERSION: 2.0 — datos desde JSON
import React from 'react';
import { Box, Image, Heading, Text, VStack, SimpleGrid, Container } from '@chakra-ui/react';
import data from '../data/donativos.json';

export default function Donativos() {
  return (
    <Box bg="bg.default" flex="1">
      <Container maxW="container.xl" py={{ base: 8, md: 12 }}>
        <Heading textAlign="center" mb={6} color="text.default">Donativos</Heading>

        <Box p={6} bg="bg.card" borderRadius="xl" boxShadow="sm" maxW="800px" mx="auto" mb={8} border="1px solid" borderColor="border.default">
          <Text fontSize="lg" color="text.muted" textAlign="center">
            “Agradecemos profundamente tu generosidad. Cada donativo será utilizado de buena fe para fortalecer nuestra comunidad y expandir el mensaje de fe y esperanza.”
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          {data.items.map((bank, index) => (
            <Box
              key={`${bank.bankName}-${index}`}
              borderWidth="1px"
              borderRadius="xl"
              overflow="hidden"
              bg="bg.card"
              boxShadow="sm"
              transition="all .25s ease"
              _hover={{ transform: 'translateY(-4px)', boxShadow: 'md' }}
              p={4}
              textAlign="center"
            >
              <VStack spacing={4}>
                <Image
                  src={bank.logo}
                  alt={`Logo ${bank.bankName}`}
                  boxSize="90%"
                  objectFit="contain"
                  borderRadius="lg"
                  border="1px solid"
                  borderColor="border.default"
                  fallbackSrc="https://via.placeholder.com/100?text=Logo"
                />
                <Heading size="md" color="text.default">{bank.bankName}</Heading>
                <Text fontWeight="bold" color="text.muted">Cuenta: {bank.accountNumber}</Text>
                <Text fontWeight="bold" color="text.muted">Destinatario: {bank.destinatario}</Text>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
